import React from "react";
import GsPyqs from "../components/pyq/GsPyqs";
import MainsPyqs from "../components/pyq/MainsPyqs";
import OptionalPyqs from "../components/pyq/OptionalPyqs";

function PyqPage() {
  return (
    <div>
      <GsPyqs />
      <MainsPyqs />
      <OptionalPyqs />
    </div>
  );
}

export default PyqPage;
